<div class="wrapper">
    <div class="not-found-container">
        <h1 *ngIf="!isOperatorNotFound">404 - Page not found</h1>
        <h1 *ngIf="isOperatorNotFound">404 - Operator not found</h1>
        <button *ngIf="!isOperatorNotFound" mat-raised-button [routerLink]="['']" class="return-button" id="continue" type="submit">
            Return to Login
        </button>
    </div>
</div>



